<template>
  <div>
    <ul v-chat-scroll class="chatbox p-2 mb-2">
      <li v-for="chat in chats" :key="chat.id">
        <ChatItem :chat="chat"/>
      </li>
    </ul>
    <b-form @submit.prevent="sendMessage">
      <b-input-group>
        <b-form-input
          id="messageInput"
          name="message"
          ref="message"
          type="text"
          maxlength="1000"
          v-model="message"
          v-validate="'required'"
          :state="!errors.has('message')"
          aria-describedby="messageLiveFeedback"
          placeholder="Entrez votre message ici!"
          data-vv-as="&quot;Message&quot;"
          size="lg"
        />
        <b-input-group-append>
          <b-button type="submit" variant="primary" size="lg" title="Envoyer" :disabled="false">
            Envoyer
            <i class="fa fa-paper-plane fa-lg fa-fw"></i>
          </b-button>
        </b-input-group-append>
        <b-form-invalid-feedback
          id="messageLiveFeedback"
          v-if="errors.has('message')"
        >{{ errors.first('message') }}</b-form-invalid-feedback>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ChatItem from "./ChatItem";

export default {
  name: "ChatBox",
  components: {
    ChatItem
  },
  mounted: function() {
    this.socketSetHandle(this.loggedUser.username);
    this.socketSetChat();
  },
  computed: {
    ...mapState({
      loggedUser: state => state.account.user,
      chats: state => state.chat.chats,
      handle: state => state.chat.handle
    })
  },
  data: function() {
    return {
      message: ""
    };
  },
  sockets: {
    chat: function(chat) {
      this.socketAddChat(chat);
    }
  },
  methods: {
    ...mapActions("chat", [
      "socketSetChat",
      "socketAddChat",
      "socketSetHandle"
    ]),
    async sendMessage() {
      if (this.message) {
        const chat = {
          handle: this.handle,
          message: this.message,
          createdAt: this.$moment()
        };
        await this.$socket.emit("chat", chat);
        this.message = "";
      }
    }
  }
};
</script>

<style>
.chatbox {
  overflow-x: auto;
  height: 50vh;
  background-color: #fff;
  border: 1px solid #32cd32;
  border-radius: 0.25rem;
}
.chatbox li {
  list-style: none;
  text-align: left;
}
</style>

